
export default {
  name: "TeamMemberModal",
  props: {
    member: Object,
    index: Number,
  },
}
